import createSymbol, { createInternalSymbol } from 'lib/core/createSymbol';

const createRiskWeeklySymbol = createSymbol('RISK_WEEKLY_REPORT');
const createRiskWeeklyInternalSymbol = createInternalSymbol('RISK_WEEKLY_REPORT');

export default {
  // Week picker options
  FETCH_WEEKS: createRiskWeeklySymbol('FETCH_WEEKS'),
  SET_FETCH_WEEKS_SUCCESS: createRiskWeeklySymbol('SET_FETCH_WEEKS_SUCCESS'),
  SET_FETCH_WEEKS_FAILURE: createRiskWeeklySymbol('SET_FETCH_WEEKS_FAILURE'),

  // Live Dashboard overview payload
  FETCH_OVERVIEW: createRiskWeeklySymbol('FETCH_OVERVIEW'),
  SET_FETCH_OVERVIEW_SUCCESS: createRiskWeeklySymbol('SET_FETCH_OVERVIEW_SUCCESS'),
  SET_FETCH_OVERVIEW_FAILURE: createRiskWeeklySymbol('SET_FETCH_OVERVIEW_FAILURE'),

  // Per-department alert drilldown, keyed by brand|department so several can be open at once
  FETCH_DEPARTMENT_DETAIL: createRiskWeeklySymbol('FETCH_DEPARTMENT_DETAIL'),
  SET_FETCH_DEPARTMENT_DETAIL_SUCCESS: createRiskWeeklySymbol('SET_FETCH_DEPARTMENT_DETAIL_SUCCESS'),
  SET_FETCH_DEPARTMENT_DETAIL_FAILURE: createRiskWeeklySymbol('SET_FETCH_DEPARTMENT_DETAIL_FAILURE'),

  // Partner coverage probe. Not keyed and not fetched on load: it reads outside the report's
  // partner scope, so it runs only when a reader opens the panel.
  FETCH_PARTNER_COVERAGE: createRiskWeeklySymbol('FETCH_PARTNER_COVERAGE'),
  SET_FETCH_PARTNER_COVERAGE_SUCCESS: createRiskWeeklySymbol('SET_FETCH_PARTNER_COVERAGE_SUCCESS'),
  SET_FETCH_PARTNER_COVERAGE_FAILURE: createRiskWeeklySymbol('SET_FETCH_PARTNER_COVERAGE_FAILURE'),

  // ===================================================================================
  // DISABLED - action types for the five views the first production release does not ship.
  // RMT8993, 2026-09-14; see docs/report_docs/13-live-dashboard-only.md.
  // ===================================================================================
  // // GRMT Under Test view
  // FETCH_GRMT: createRiskWeeklySymbol('FETCH_GRMT'),
  // SET_FETCH_GRMT_SUCCESS: createRiskWeeklySymbol('SET_FETCH_GRMT_SUCCESS'),
  // SET_FETCH_GRMT_FAILURE: createRiskWeeklySymbol('SET_FETCH_GRMT_FAILURE'),

  // // Per-setting GRMT drilldown, keyed brand|setting|report|filter — each brand's table has its
  // // own open row, and the status filter is part of the request because the cap is applied after it
  // FETCH_GRMT_SETTING_DETAIL: createRiskWeeklySymbol('FETCH_GRMT_SETTING_DETAIL'),
  // SET_FETCH_GRMT_SETTING_DETAIL_SUCCESS: createRiskWeeklySymbol('SET_FETCH_GRMT_SETTING_DETAIL_SUCCESS'),
  // SET_FETCH_GRMT_SETTING_DETAIL_FAILURE: createRiskWeeklySymbol('SET_FETCH_GRMT_SETTING_DETAIL_FAILURE'),

  // // Employee & Department Analytics
  // FETCH_EMPLOYEE_ANALYTICS: createRiskWeeklySymbol('FETCH_EMPLOYEE_ANALYTICS'),
  // SET_FETCH_EMPLOYEE_ANALYTICS_SUCCESS: createRiskWeeklySymbol('SET_FETCH_EMPLOYEE_ANALYTICS_SUCCESS'),
  // SET_FETCH_EMPLOYEE_ANALYTICS_FAILURE: createRiskWeeklySymbol('SET_FETCH_EMPLOYEE_ANALYTICS_FAILURE'),

  // // Per-analyst detail, keyed brand|employeeId so each brand's table keeps its own open row
  // FETCH_EMPLOYEE_DETAIL: createRiskWeeklySymbol('FETCH_EMPLOYEE_DETAIL'),
  // SET_FETCH_EMPLOYEE_DETAIL_SUCCESS: createRiskWeeklySymbol('SET_FETCH_EMPLOYEE_DETAIL_SUCCESS'),
  // SET_FETCH_EMPLOYEE_DETAIL_FAILURE: createRiskWeeklySymbol('SET_FETCH_EMPLOYEE_DETAIL_FAILURE'),

  // // Partner & Trigger Analytics, keyed by grain so switching back is instant
  // FETCH_PARTNER_TRIGGER: createRiskWeeklySymbol('FETCH_PARTNER_TRIGGER'),
  // SET_FETCH_PARTNER_TRIGGER_SUCCESS: createRiskWeeklySymbol('SET_FETCH_PARTNER_TRIGGER_SUCCESS'),
  // SET_FETCH_PARTNER_TRIGGER_FAILURE: createRiskWeeklySymbol('SET_FETCH_PARTNER_TRIGGER_FAILURE'),

  // Coverage of the fact store. One request per session rather than per view: it describes what
  // exists, which does not change while a reader is choosing a range.
  FETCH_CALENDAR: createRiskWeeklySymbol('FETCH_CALENDAR'),
  SET_FETCH_CALENDAR_SUCCESS: createRiskWeeklySymbol('SET_FETCH_CALENDAR_SUCCESS'),
  SET_FETCH_CALENDAR_FAILURE: createRiskWeeklySymbol('SET_FETCH_CALENDAR_FAILURE'),

  // Explore's metrics cube, keyed by grain. Every control other than the grain re-pivots the cube
  // already in the store, so only a grain change fetches.
  FETCH_EXPLORE_CUBE: createRiskWeeklySymbol('FETCH_EXPLORE_CUBE'),
  SET_FETCH_EXPLORE_CUBE_SUCCESS: createRiskWeeklySymbol('SET_FETCH_EXPLORE_CUBE_SUCCESS'),
  SET_FETCH_EXPLORE_CUBE_FAILURE: createRiskWeeklySymbol('SET_FETCH_EXPLORE_CUBE_FAILURE'),
  // Statistics: one day's alerts, keyed by day and brand.
  FETCH_DAILY_STATISTICS: createRiskWeeklySymbol('FETCH_DAILY_STATISTICS'),
  SET_FETCH_DAILY_STATISTICS_SUCCESS: createRiskWeeklySymbol('SET_FETCH_DAILY_STATISTICS_SUCCESS'),
  SET_FETCH_DAILY_STATISTICS_FAILURE: createRiskWeeklySymbol('SET_FETCH_DAILY_STATISTICS_FAILURE'),

  // // Insights. A single section, not keyed: the view describes one week and ignores the report's
  // // brand and range filters, so there is nothing to key on.
  // FETCH_INSIGHTS: createRiskWeeklySymbol('FETCH_INSIGHTS'),
  // SET_FETCH_INSIGHTS_SUCCESS: createRiskWeeklySymbol('SET_FETCH_INSIGHTS_SUCCESS'),
  // SET_FETCH_INSIGHTS_FAILURE: createRiskWeeklySymbol('SET_FETCH_INSIGHTS_FAILURE'),

  CANCEL_SDK_CALL: createRiskWeeklySymbol('CANCEL_SDK_CALL'),

  // Filter state lives in the store as well as the URL so a refetch has one source
  SET_FILTER: createRiskWeeklyInternalSymbol('SET_FILTER'),
  CLEAR_STATE: createRiskWeeklyInternalSymbol('CLEAR_STATE'),

  // ---- Configuration management ----

  // The configuration screen's first payload: small areas whole, vocabularies, counts, versions
  FETCH_CONFIG_OVERVIEW: createRiskWeeklySymbol('FETCH_CONFIG_OVERVIEW'),
  SET_FETCH_CONFIG_OVERVIEW_SUCCESS: createRiskWeeklySymbol('SET_FETCH_CONFIG_OVERVIEW_SUCCESS'),
  SET_FETCH_CONFIG_OVERVIEW_FAILURE: createRiskWeeklySymbol('SET_FETCH_CONFIG_OVERVIEW_FAILURE'),

  // One page of a large area, keyed by area so the tabs keep their own list and paging state
  FETCH_CONFIG_PAGE: createRiskWeeklySymbol('FETCH_CONFIG_PAGE'),
  SET_FETCH_CONFIG_PAGE_SUCCESS: createRiskWeeklySymbol('SET_FETCH_CONFIG_PAGE_SUCCESS'),
  SET_FETCH_CONFIG_PAGE_FAILURE: createRiskWeeklySymbol('SET_FETCH_CONFIG_PAGE_FAILURE'),

  // The mapping queue. Separate from the overview because it needs a report build
  FETCH_CONFIG_UNMAPPED: createRiskWeeklySymbol('FETCH_CONFIG_UNMAPPED'),
  SET_FETCH_CONFIG_UNMAPPED_SUCCESS: createRiskWeeklySymbol('SET_FETCH_CONFIG_UNMAPPED_SUCCESS'),
  SET_FETCH_CONFIG_UNMAPPED_FAILURE: createRiskWeeklySymbol('SET_FETCH_CONFIG_UNMAPPED_FAILURE'),

  // Write path. One pair for save and one for delete: the UI reports them differently
  SAVE_CONFIG_ROW: createRiskWeeklySymbol('SAVE_CONFIG_ROW'),
  SET_SAVE_CONFIG_ROW_SUCCESS: createRiskWeeklySymbol('SET_SAVE_CONFIG_ROW_SUCCESS'),
  SET_SAVE_CONFIG_ROW_FAILURE: createRiskWeeklySymbol('SET_SAVE_CONFIG_ROW_FAILURE'),

  DELETE_CONFIG_ROW: createRiskWeeklySymbol('DELETE_CONFIG_ROW'),
  SET_DELETE_CONFIG_ROW_SUCCESS: createRiskWeeklySymbol('SET_DELETE_CONFIG_ROW_SUCCESS'),
  SET_DELETE_CONFIG_ROW_FAILURE: createRiskWeeklySymbol('SET_DELETE_CONFIG_ROW_FAILURE'),

  // Clears the last save result, so a warning banner can be dismissed
  CLEAR_CONFIG_SAVE_RESULT: createRiskWeeklyInternalSymbol('CLEAR_CONFIG_SAVE_RESULT'),

  // Edit history, keyed area|recordId
  FETCH_CONFIG_HISTORY: createRiskWeeklySymbol('FETCH_CONFIG_HISTORY'),
  SET_FETCH_CONFIG_HISTORY_SUCCESS: createRiskWeeklySymbol('SET_FETCH_CONFIG_HISTORY_SUCCESS'),
  SET_FETCH_CONFIG_HISTORY_FAILURE: createRiskWeeklySymbol('SET_FETCH_CONFIG_HISTORY_FAILURE'),

  // Drops the backend's caches. Not a fetch: it changes server state, and what comes back is a
  // report of what went rather than report data
  CLEAR_SERVER_CACHE: createRiskWeeklySymbol('CLEAR_SERVER_CACHE'),
  SET_CLEAR_SERVER_CACHE_SUCCESS: createRiskWeeklySymbol('SET_CLEAR_SERVER_CACHE_SUCCESS'),
  SET_CLEAR_SERVER_CACHE_FAILURE: createRiskWeeklySymbol('SET_CLEAR_SERVER_CACHE_FAILURE')

};
